import React from 'react';

const CTASection = () => {
    return (
        <section className="cta-section">
            <div className="cta-content">
                <h2 className="cta-title">Ready to join the digital metallurgy revolution?</h2>
                <p className="cta-subtitle">Request a demo today to see Ferritico in action. Transform your steel development process and unlock the future of steel - faster, greener, and more cost-effective.</p>
                <div className="cta-buttons">
                    <a href="#contact" className="cta-primary">Book a Demo Today</a>
                    <a href="#contact" className="cta-secondary">Contact Us</a>
                </div>
            </div>
        </section>
    );
};

export default CTASection;